module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Guitarra RO.d6940b8b.png";